const api_uri = process.env.REACT_APP_API_URI;

export const getImgUrl = imgName => {
  if (imgName?.includes("/files/"))
    return api_uri + imgName;

  return api_uri + "/files/" + imgName;
}

export const request = async (endpoint = '', cb = Function.prototype, errCb = Function.prototype) => {
  try {
    // Добавляем завершающий слэш для Django сервера
    const normalizedEndpoint = endpoint.endsWith('/') ? endpoint : endpoint + '/';
    const res = await fetch(api_uri + "/api" + normalizedEndpoint)
    const data = await res.json();
    if (data === undefined || data === null || data.length === 0)
      return errCb("Data not found")
    
    cb(data);
  } catch (err) {
    errCb(err);
  }
}
